<template>
  <div class="index" style="min-height: 100vh">
    <div class="index__main-content">
      <div class="logo-container">
        <img
          class="logo"
          src="../../public/img/icons/hermes-icon.png"
          alt="Logo Hermes"
        />
      </div>

      <div class="content-container" :class="showFeedback ? 'feedback-active' : 'read-active'">
        <h4 class="index-title app-title with-bar">
          Leitura de QR Code
          <div class="line-big"></div>
        </h4>
        <div class="qr-container container-list" v-if="!showFeedback">
          <button class="back-top-btn" @click="goBack">
            <img
              src="../../public/img/chevron-left-solid.svg"
              style="width: 12px"
            />
          </button>
          <p class="instruction-text">{{ instructionText }}</p>

          <QrCodeReader v-if="!showInput"  
            :capturedImageUrl="capturedImageUrl"
            @onInsertCode="insertCode"
          >
            <video
              ref="videoElement"
              class="camera-feed"
              autoplay
              playsinline
            ></video>
          </QrCodeReader>

          <QrCodeInput
            v-else
            @onSubmit="handleSubmitCode"
            @onReadQrCode="toggleReadQrCode"
            @onFocus="showKeyboard = true"
            :inputCode="inputCode"
          />
        </div>

        <FeedbackCard
          v-if="showFeedback"
          :isSuccess="success"
          :message="errorMessage"
        ></FeedbackCard>
        <button
          class="try-again-btn"
          @click="tryAgain"
          v-if="showFeedback && !success"
        >
          Tentar novamente
        </button>
        <button
          v-if="showFeedback && success"
          @click="goBack"
          class="capture-btn"
        >
          Voltar para tela inicial
        </button>
      </div>
       <Keyboard
      v-if="showKeyboard"
      v-model="inputCode"
      @enter="handleEnter"
      @close="showKeyboard = false"
      :mask="qrCodeFormatInput"
    />
    </div>
  </div>
</template>

<script>
import { BrowserMultiFormatReader } from "@zxing/library";
import FeedbackCard from "../components/FeedbackCard.vue";
import QrCodeService from "../services/QrCodeService";
import QrCodeInput from "../components/QrCodeInput.vue";
import QrCodeReader from "../components/QrCodeReader.vue";
import Keyboard from "../components/Keyboard.vue";

export default {
  data() {
    return {
      videoStream: null,
      capturedImageUrl: null,
      qrcodeService: new QrCodeService(),
      payload: {
        codigo: null,
      },
      success: false,
      isLoading: false,
      showFeedback: false,
      codeReader: null,
      errorMessage: "",
      showInput: false,
      inputCode: '',
      showKeyboard: false,
    };
  },
  components: {
    FeedbackCard,
    QrCodeInput,
    QrCodeReader,
    Keyboard,
  },
  methods: {
    goBack() {
      this.stopCamera();
      this.$router.push("/home/visitors");
    },

    async startCamera() {
      if (this.codeReader) {
        return;
      }
      this.codeReader = new BrowserMultiFormatReader();

      this.codeReader
        .listVideoInputDevices()
        .then((videoInputDevices) => {
          const selectedDeviceId = videoInputDevices[0].deviceId;

          this.codeReader.decodeFromVideoDevice(
            selectedDeviceId,
            this.$refs.videoElement,
            (result, err) => {
              if (!this.videoStream && this.$refs.videoElement.srcObject) {
                this.videoStream = this.$refs.videoElement.srcObject;
              }
              if (result) {
                console.log("QR Code encontrado:", result.getText());
                const qrCodeText = result.getText();
                this.payload.codigo = qrCodeText;
                this.captureImage();
                this.stopCamera();
                this.sendImage();
              }
              if (err && err.name !== "NotFoundException") {
                console.log("ERRRRO aqui", err);
                this.showInput = true;
              } else {
              }
            }
          );
        })
        .catch((err) => {
          console.error("Erro ao acessar a câmera:", err);
          this.errorMessage =
            "Não foi possível acessar a câmera. Por favor, verifique as permissões.";
          this.showFeedback = true;
        });
    },

    stopCamera() {
      console.log("Parando a câmera...");
      if (this.codeReader) {
        this.codeReader.reset();
        this.codeReader = null;
      }
      if (this.videoStream) {
        this.videoStream.getTracks().forEach((track) => track.stop());
        this.videoStream = null;
      }
      if (this.$refs.videoElement) {
        this.$refs.videoElement.srcObject = null;
      }
    },

    captureImage() {
      const video = this.$refs.videoElement;
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      const frameElement = document.querySelector(".qr-frame");

      const videoRect = video.getBoundingClientRect();
      const frameRect = frameElement.getBoundingClientRect();

      const scaleX = video.videoWidth / videoRect.width;
      const scaleY = video.videoHeight / videoRect.height;

      const cropX = (frameRect.left - videoRect.left) * scaleX;
      const cropY = (frameRect.top - videoRect.top) * scaleY;
      const cropWidth = frameRect.width * scaleX;
      const cropHeight = frameRect.height * scaleY;

      canvas.width = cropWidth;
      canvas.height = cropHeight;

      context.drawImage(
        video,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );

      canvas.toBlob(
        (blob) => {
          if (blob) {
            const file = new File([blob], "qrcode_image.jpg", {
              type: "image/jpeg",
              lastModified: Date.now(),
            });

            this.capturedImageUrl = URL.createObjectURL(file);
          }
        },
        "image/jpeg",
        0.9
      );
    },

    tryAgain() {
      this.capturedImageUrl = null;
      this.success = false;
      this.showFeedback = false;
      this.payload.codigo = null;
      this.startCamera();
    },
    toggleLoading() {
      this.$store.commit('toggleLoading')
    },
    async sendImage() {
      // this.toggleLoading();
      this.$store.commit('toggleLoading')
      await this.qrcodeService
        .readQrCode(this.payload)
        .then((response) => {
          console.log("QR Code lido com sucesso:", response);
          if (response.success) {
            this.success = true;
            this.$store.commit("setQrCodeSchedule", response.data);
          }
        })
        .catch((error) => {
          console.error("Erro ao ler o QR Code:", error);
          this.success = false;

          if (error?.response?.data?.message) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage =
              "Erro ao processar o QR Code. Por favor, tente novamente.";
          }
        });
      // this.toggleLoading();
      this.$store.commit('toggleLoading')

      this.showFeedback = true;
    },
    async handleSubmitCode(inputCode) {
      this.payload.codigo = inputCode;
      this.sendImage();
    },
    insertCode() {
      this.stopCamera();
      this.showInput = true;
    },
    toggleReadQrCode() {
      this.startCamera();
      this.showInput = false;
    },
    qrCodeFormatInput(input) {
      const clean = input.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
  return clean.match(/.{1,4}/g)?.join("-") || "";
    },
    onKeyboardInput(value) {
      this.inputCode = value;
      this.qrCodeFormatInput();
    },
    handleEnter() {
      if (this.inputCode !== "") {
        this.handleSubmitCode(this.inputCode);
        this.showKeyboard = false;
      }
    },
  },
  mounted() {
    this.startCamera();
  },
  computed: {
    instructionText() {
      return this.showInput
        ? "Insira o código manualmente."
        : "Posicione o QR Code dentro da área.";
    },
  },
  beforeDestroy() {
    this.stopCamera();
  },
};
</script>

<style scoped>
.index {
  position: relative;
  min-height: 100vh;
  overflow-x: hidden;
}

.camera-feed {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.background-elements {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* z-index: 1; */
}

.logo-container {
  position: absolute;
  top: 20px;
  left: 80px;
  z-index: 10;
}

.logo {
  width: 60px;
  /* height: 100px; */
}

.index__banner {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: none !important;
}

.index__main-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  height: 100vh;
  z-index: 10;
  padding: 20px;
  box-sizing: border-box;
  background-color: #3c3341;
}

.instruction-text {
  color: #888791;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 15px;
}

.back-top-btn {
  position: absolute;
  top: -60px;
  left: 0;
  z-index: 1000;
  background-color: transparent;
  border: none;
  /* border-radius: 50px; */
  /* padding: 10px 20px; */
  color: #e86b53;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15); */
  transition: all 0.3s ease;
}

.back-top-btn:hover {
  transform: translateX(-3px);
  text-decoration: underline;
}

.content-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 50%;
  min-width: 550px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 4px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  padding: 20px;
  gap: 15px;
}

.read-active{
  max-height: 600px;
  min-height: 600px;
  height: 600px;
}

.feedback-active{
  max-height: 480px;
  min-height: 480px;
  height: 480px;
}

.qr-container {
  max-width: 100%;
  justify-content: center;
  position: relative;
}

.index-title {
  font-size: 1.5rem;
  text-align: center;
  font-weight: 400;
  color: #333;
  margin-bottom: 5px;
}

.btn-group {
  width: 70%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 25px;
}

.capture-btn {
  padding: 15px 20px;
  font-size: 1rem;
  width: 50%;
  background-color: #e86b53;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.send-btn {
  padding: 12px 30px;
  font-size: 1rem;
  background-color: #e86b53;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.capture-btn:hover {
  background-color: #d4553f;
}

.try-again-btn {
  padding: 15px 30px;
  font-size: 1rem;
  background-color: #a82c13;
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  /* height: 100%; */
  width: 40%;
  gap: 8px;
}

.preview-container {
  position: relative;
  width: 70%;
  aspect-ratio: 1/1;
  max-height: 60vh;
  margin: 0 auto 20px;
  overflow: hidden;
  border-radius: 10px;
  background-color: #000;
}

.input-option--btn {
  font-size: 14px;
  color: #de3517;
  opacity: 0.8;
  font-weight: 500;
  text-decoration: underline;
  margin-top: 10px;
  background-color: transparent;
  border: none;
}

.image-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  height: 90%;
  border: 3px solid rgba(232, 107, 83, 0.7);
  border-radius: 10px;
  pointer-events: none;
  box-shadow: 0 0 0 100vmax rgba(0, 0, 0, 0.7);
}

@media (min-width: 768px) {
  .index-title {
    font-size: 1.8rem;
  }

  .instruction-text {
    font-size: 1.1rem;
  }

  /* .qr-scanner-container {
    max-height: 60vh;
  } */
}

@media (min-width: 1200px) {
  .content-container {
    max-width: 700px;
  }
}
</style>
